
<!-- <button class="layout-config-button p-link" type="button" (click)="onConfigButtonClick()" >
    <i class="pi pi-sparkles"></i>
</button> -->

<p-dialog [(visible)]="visible" position="center" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-config-sidebar " [style]="{width:'40vw', overflow:'hidden', height:'90vh' }" [closeOnEscape]="false" [modal]="true">
    <app-chat-ai-open [myUser]="myUser" [modeSelected]="2" *ngIf="visible"></app-chat-ai-open>
</p-dialog>
